import { makeStyles } from '@material-ui/core/styles';
//PIE-TODO : Remove or conditions after full PIE implementation
const useStyles = makeStyles(({ palette, variables }) => ({
  userLogoBox: {
    width: '40px',
    height: '40px',
    borderRadius: variables?.radiusRoundedB || '8px',
    border: `2px solid ${palette?.jet?.borderDefault || '#efedea'}`,
    position: 'relative',
    minWidth: '40px',
  },
  userLogoImage: {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: `4px solid ${palette.primary.contrastText }`,
    borderRadius: '50%',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    textIndent: '-99999px',
    '&::after':{
      backgroundColor:'#10D365',
      width:12,
      height:12,
      position:'absolute',
      content:'""',
      display:'block',
      bottom:-6,
      right:-6,
      borderRadius:'100%',
      border:'1px solid #fff'
    }
  },
  avatarLetterBox: {
    marginRight: '30px',
  },
}));

export default useStyles;
